import { render, staticRenderFns } from "./AppNavigationSettings.vue?vue&type=template&id=007ada94&scoped=true&"
import script from "./AppNavigationSettings.vue?vue&type=script&lang=js&"
export * from "./AppNavigationSettings.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationSettings.vue?vue&type=style&index=0&id=007ada94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ada94",
  null
  
)

export default component.exports